module.exports = __webpack_public_path__ + "media/images/illustrations/starworks-student-01-ec352ef0aeb2b36b712aea2fd18c44e1.svg";